import NamaAutomation from "@/utils/automation/NamaAutomation.ts";

// Exposed only when the server reports debug mode (see ERPVueHTMLServlet). These helpers can save
// records and run GUI actions, so they must never be reachable on a customer deployment.
export function installNamaAutomation() {
  if (!NamaAutomation.isEnabled())
    return;
  (window as any).__nama = NamaAutomation;
}
